<mat-progress-bar *ngIf="loading$ | async" class="loading-bar" color="accent" mode="indeterminate"></mat-progress-bar>

<ngc-totp-mfa-setup *ngIf="!recoveryCodes"
                    [loading$]="loading$"
                    (success)="onSuccess($event)"
                    (cancel)="onClose()"
>
</ngc-totp-mfa-setup>

<ngc-recovery-codes *ngIf="recoveryCodes?.length > 0"
                    [recoveryCodes]="recoveryCodes"
                    [recoveryCodesHaveToBeSaved]="true"
                    (closeRecoveryCodes)="onSuccess()"
>
</ngc-recovery-codes>
